// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#mandatoryForm .form-group{margin-bottom:4px}", "",{"version":3,"sources":["webpack://./resources/js/components_new/Configurator/AddMandatoryBoothRefinementModal.vue"],"names":[],"mappings":"AACA,2BACE,iBAAF","sourcesContent":["\n#mandatoryForm .form-group {\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
